import { DashboardNavbar } from './DashboardNavbar'
import { NavbarAuthorized } from './NavbarAuthorized'
import { NavbarB2B } from './NavbarB2B'

export const Navbar = {
  Authorized: NavbarAuthorized,
  Dashboard: DashboardNavbar,
  Public: NavbarAuthorized,
  B2B: NavbarB2B
}